import React, { useRef } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import FeedbackProblemProductPickers, {
    type FeedbackProblemProductPickersHandle,
} from '@components/feedbackProblemProductPickers';
import { setPostImage } from '@images/imageUrls';
import { useFeedbackFormFields } from '../useFeedbackFormFields';
import styles from './index.module.scss';

interface FeedbackFormFieldsProps {
    setPost?: any;
    thread?: any;
}

const PCFeedbackFormFields: React.FC<FeedbackFormFieldsProps> = ({ setPost, thread }) => {
    const {
        postData,
        setPostData,
        problemLabel,
        productLabel,
        handleProblemSelect,
        handleProductSelect,
    } = useFeedbackFormFields(setPost, thread);
    const pickerRef = useRef<FeedbackProblemProductPickersHandle>(null);

    const renderSelectRow = (
        label: string,
        required: boolean,
        value: string,
        placeholder: string,
        onClick: () => void,
    ) => (
        <div className={styles.formRow}>
            <div className={styles.label}>
                {label}
                {required && <span className={styles.required}>*</span>}
            </div>
            <div className={styles.control}>
                <button type="button" className={styles.selectTrigger} onClick={onClick}>
                    <span className={classNames(styles.valueText, !value && styles.placeholder)}>
                        {value || placeholder}
                    </span>
                    <img src={setPostImage.selectIcon} alt="" className={styles.arrow} />
                </button>
            </div>
        </div>
    );

    const renderInputRow = (
        label: string,
        required: boolean,
        value: string,
        placeholder: string,
        field: 'systemVersion' | 'imei' | 'phone',
        inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'],
    ) => (
        <div className={styles.formRow}>
            <div className={styles.label}>
                {label}
                {required && <span className={styles.required}>*</span>}
            </div>
            <div className={styles.control}>
                <input
                    className={styles.textInput}
                    value={value}
                    placeholder={placeholder}
                    inputMode={inputMode}
                    onChange={(e) => setPostData({ [field]: e.target.value })}
                />
            </div>
        </div>
    );

    return (
        <>
            <div className={styles.formBox}>
                {renderSelectRow(
                    '问题类型',
                    true,
                    problemLabel,
                    '请选择',
                    () => pickerRef.current?.openProblemPicker(),
                )}
                {renderSelectRow(
                    '手机型号',
                    true,
                    productLabel,
                    '请选择',
                    () => pickerRef.current?.openProductPicker(),
                )}
                {renderInputRow(
                    '软件版本号',
                    true,
                    postData.systemVersion || '',
                    '关于手机-版本信息-软件版本号',
                    'systemVersion',
                )}
                {renderInputRow(
                    'IMEI1码',
                    false,
                    postData.imei || '',
                    '在拨号界面输入*#06#(仅官方可见)',
                    'imei',
                )}
                {renderInputRow(
                    '联系方式',
                    false,
                    postData.phone || '',
                    '请填写手机号码(仅官方可见)',
                    'phone',
                    'tel',
                )}
            </div>

            <FeedbackProblemProductPickers
                ref={pickerRef}
                problemId={postData.problemId}
                productId={postData.productId}
                onProblemSelect={handleProblemSelect}
                onProductSelect={handleProductSelect}
            />
        </>
    );
};

export default inject('setPost', 'thread')(observer(PCFeedbackFormFields));
